import { Component, ViewChild, ElementRef, OnInit, Output, EventEmitter, Input } from '@angular/core';

let faceapi: any;

@Component({
  selector: 'app-capture-image',
  templateUrl: './capture-image.component.html',
  styleUrls: ['./capture-image.component.css']
})
export class CaptureImageComponent implements OnInit {
  @ViewChild('video') video: ElementRef;
  @ViewChild('canvas') canvas: ElementRef;
  videoStream: MediaStream;
  capturedImage: string | null = null;
  cameraMode: string = 'waiting';
  @Output() imageCaptured = new EventEmitter<{ submit: boolean, image: string }>();
  @Input() ninDetails: any;
  @Output() goBack = new EventEmitter<void>();


  protected readonly document = document;
  image: boolean = false;
  isloading: boolean = false;
  isSubmitting: boolean = false;
  screenHeight = window.screen.height - 271; // 1058
  minHeight = 'min-height: ' + this.screenHeight + 'px !important'

  screenHeight2 = window.screen.height - 630; // 428
  minHeight2 = 'min-height: ' + this.screenHeight2 + 'px !important'
  dataUrl: string;

  ngOnInit(): void {
  }

  @ViewChild('canvas') downloadLink: ElementRef;
  faceDictated: boolean = false;
  message: string = 'Please look at the camera and click the Capture button to take a picture of your face.';

  ngAfterViewInit() {
    this.loadFaceApiModels();
  }

  async loadFaceApiModels() {
    if (!faceapi) {
      faceapi = await import('face-api.js');
    }
    await faceapi.nets.tinyFaceDetector.loadFromUri('/assets/models');
    await faceapi.nets.faceLandmark68Net.loadFromUri('/assets/models');
    await faceapi.nets.faceRecognitionNet.loadFromUri('/assets/models');
    await faceapi.nets.faceExpressionNet.loadFromUri('/assets/models');
  }

  async capture() {
    const canvas = this.canvas.nativeElement;
    const context = canvas.getContext('2d');
    context.drawImage(this.video.nativeElement, 0, 0, canvas.width, canvas.height);
    this.isloading = true;

    // Detect faces
    const detections = await faceapi.detectAllFaces(canvas, new faceapi.TinyFaceDetectorOptions()).withFaceLandmarks();
    const detectionsWithLandmarks = await faceapi.detectAllFaces(canvas, new faceapi.TinyFaceDetectorOptions()).withFaceLandmarks();

    if (detections.length === 0) {
      this.message = 'No face detected. Please try again.';
      this.faceDictated = false;
      this.isloading = false;
      return;
    }

    if (detections.length > 1) {
      this.message = 'Multiple faces detected. Please try again.';
      this.faceDictated = false;
      this.isloading = false;
      return;
    }

    // Check if face is blurred
    // if (this.isFaceBlurred(context, detections[0])) {
    //   this.faceDictated = false;
    //   this.message = 'Face is blurred. Please try again.';
    //   this.isloading = false;
    //   return;
    // }

    // const expressions = detections[0].expressions;
    // if (expressions.happy > 0.5) {
    //   // this.message = 'Detected a smiling face!';
    // } else {
    //   this.message = 'Please smile for the camera.';
    //   this.faceDictated = false;
    //   this.isloading = false;
    //   return;
    // }

    this.image = true;
    // Convert the captured image to a data URL
    this.dataUrl = canvas.toDataURL('image/png');

    this.isloading = true;
    this.message = 'Success';
    this.cameraMode = 'redo';
    this.faceDictated = true;
    // Set the download link with the data URL
    this.downloadLink.nativeElement.style.display = 'block';
    // this.downloadLink.nativeElement.download = 'captured-image.png';
    // this.downloadLink.nativeElement.innerText = 'Save Image';
  }

  isFaceBlurred(context: CanvasRenderingContext2D, detection: any): boolean {
    const box = detection.box;
    console.log(box)
    const imageData = context.getImageData(box.x, box.y, box.width, box.height);
    const grayImageData = this.convertToGrayscale(imageData);
    const blurValue = this.calculateBlur(grayImageData);
    const blurThreshold = 100; // Adjust threshold as needed
    return blurValue < blurThreshold;
  }

  convertToGrayscale(imageData: ImageData): ImageData {
    const data = imageData.data;
    for (let i = 0; i < data.length; i += 4) {
      const avg = (data[i] + data[i + 1] + data[i + 2]) / 3;
      data[i] = data[i + 1] = data[i + 2] = avg;
    }
    return imageData;
  }

  calculateBlur(imageData: ImageData): number {
    const data = imageData.data;
    let sum = 0;
    for (let i = 0; i < data.length; i += 4) {
      sum += data[i];
    }
    const avg = sum / (data.length / 4);
    let variance = 0;
    for (let i = 0; i < data.length; i += 4) {
      variance += (data[i] - avg) ** 2;
    }
    return variance / (data.length / 4);
  }

  startCamera(): void {
    this.isloading = false;
    this.dataUrl = '';
    navigator.mediaDevices.getUserMedia({ video: { width: 400, height: 400 } })
      .then((stream) => {
        this.videoStream = stream;
        this.video.nativeElement.srcObject = stream;
        this.video.nativeElement.play();
      })
      .catch((error) => {
        console.error('Error accessing camera: ', error);
      });
    this.cameraMode = 'capture';
    this.image = false;
    // this.downloadLink.nativeElement.style.display = 'none';
  }

  continue(): void {
    this.imageCaptured.emit({ submit: true, image: this.dataUrl });
    this.stopCamera()
    this.isSubmitting = true;
  }


  continueWithNin(): void {
    this.imageCaptured.emit({ submit: true, image: null });
    this.stopCamera()
    this.isSubmitting = true;
  }

  stopCamera(): void {
    if (this.videoStream) {
      this.videoStream.getTracks().forEach(track => track.stop());
    }

    const videoElement = document.querySelector('video') as HTMLVideoElement;
    if (videoElement) {
      videoElement.srcObject = null; // detach the stream
    }

    this.videoStream = null; // clear reference
  }


}
